import { CSAlertConfiguration } from "../Model/CSAlertConfiguration";

export class GetCSAlertConfigurationList {
    constructor(
        total,
        offset,
        limit,
        records
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
        return new GetCSAlertConfigurationList(
            data.total,
            data.offset,
            data.limit,
            data.records.map((record) =>{
                return CSAlertConfiguration.createFromResponseData(record);
            }),
        );
    }
};